export const SUB_CATEGORIES_LIST_REQUEST =
  "SUB_CATEGORIES_LIST_REQUEST";
export const SUB_CATEGORIES_LIST_RESPONSE =
  "SUB_CATEGORIES_LIST_RESPONSE";

export const ADD_SUB_CATEGORY_REQUEST = "ADD_SUB_CATEGORY_REQUEST";

export const EDIT_SUB_CATEGORY_REQUEST = "EDIT_SUB_CATEGORY_REQUEST";

export const GET_SUB_CATEGORY_DETAILS_REQUEST =
  "GET_SUB_CATEGORY_DETAILS_REQUEST";

export const GET_SUB_CATEGORY_DETAILS_RESPONSE =
  "GET_SUB_CATEGORY_DETAILS_RESPONSE";

export const DELETE_SUB_CATEGORY_REQUEST =
  "DELETE_SUB_CATEGORY_REQUEST";

export const SUB_CATEGORY_PRODUCTS_LIST_REQUEST =
  "SUB_CATEGORY_PRODUCTS_LIST_REQUEST";

export const SUB_CATEGORY_PRODUCTS_LIST_RESPONSE =
  "SUB_CATEGORY_PRODUCTS_LIST_RESPONSE";
